import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from '../locales/en/translation.json';
import translationFR from '../locales/fr/translation.json';

// Translation resources
const resources = {
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem('language') || 'en', // default language
    fallbackLng: 'en',
    keySeparator: '.',
    returnEmptyString: false,
    returnNull: false,
    saveMissing: false,
    missingKeyHandler: false,
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    react: {
      useSuspense: false // Prevent suspense to avoid rendering issues
    },
    // Don't return the key if translation is missing - return empty instead
    parseMissingKeyHandler: () => ''
  });

export default i18n;
